'use strict';

angular.module('offersController', [])

.controller('OffersController', ['$scope', '$rootScope', '$log', '$q','$routeParams',
    function ($scope, $rootScope, $log, $q, $routeParams) {    
    
    //Check auth credentials
    var currentUser = $rootScope.currentUser
    , ekey = currentUser.authdata
    , name = currentUser.name
    , today = moment().unix()
    ;

    $rootScope.header.show = false;


}]);